import React, { FC, useRef } from 'react';
import { useIsChannelStatusDelayed } from '../../../ticketus/cashin/useIsChannelStatusDelayed';
import i18n from '../../../../common/i18n';
import { formatMoneyAmount } from '../../../../common/util';
import clsx from 'clsx';
import { logCashinDialogOpen } from '../../../../common/logging/cashin/log';
import SettingsIcon from '../../../../icons/SettingsIcon';
import { useCashinButton } from '../../../ticketus/cashin/useCashinHooks';
import { fromJS } from 'immutable';

const CashinButtonContent: FC<{
    large: boolean;
    ticketId: string;
    handleClick: any;
    handleClickAutoCashin: any;
}> = ({ large, ticketId, handleClick, handleClickAutoCashin }) => {
    const cashinButtonRef = useRef(null);
    const autoCashinButtonRef = useRef(null);
    const { hidden, disabled, cashinOffer, autoCashinDisabled } = useCashinButton(ticketId);
    const isChannelStatusDelayed = useIsChannelStatusDelayed(cashinOffer);
    if (hidden || isChannelStatusDelayed) {
        return null;
    }
    const isSoloTicket = cashinOffer.betIds.length === 1;
    const autoCashinLimit = cashinOffer.automaticTransactionLimit;
    const autoCashinTooltip = autoCashinLimit
        ? i18n('nui.cashin.autoCashin.activeTooltip', formatMoneyAmount(autoCashinLimit))
        : i18n('nui.cashin.autoCashin.tooltip');
    return (
        <div
            className={'fs-0 p-rel d-inline-block'}
            onClick={e => {
                e.stopPropagation();
                e.preventDefault();
            }}
        >
            <div className="btn-group">
                <button
                    ref={cashinButtonRef}
                    className={clsx('btn btn-success', {
                        'cashin-button-black': !isSoloTicket,
                        'btn-lg': large,
                        'btn-xs': !large
                    })}
                    disabled={disabled}
                    title={i18n('niu.detailTiketu.cashinOffer')}
                    data-atid="cashin-btn"
                    data-testid="cashin-btn"
                    data-ticket-id={ticketId}
                    onClick={e => {
                        logCashinDialogOpen({ ticketId, offer: fromJS(cashinOffer) });
                        handleClick(cashinButtonRef)(e);
                    }}
                >
                    {formatMoneyAmount(cashinOffer.amount)}
                </button>

                <button
                    ref={autoCashinButtonRef}
                    className={clsx('btn btn-fluid flex-center', {
                        'btn-xs': !large,
                        'btn-lg': large,
                        'btn-success': !autoCashinLimit,
                        'btn-primary': autoCashinLimit
                    })}
                    disabled={disabled || autoCashinDisabled}
                    title={autoCashinTooltip}
                    data-atid="auto-cashin-btn"
                    onClick={handleClickAutoCashin(autoCashinButtonRef)}
                >
                    <SettingsIcon
                        classNames={clsx(isSoloTicket ? 'c-white' : 'c-black-100')}
                        width={clsx({ '12px': !large, '20px': large })}
                        height={clsx({ '12px': !large, '20px': large })}
                    />
                </button>
            </div>
        </div>
    );
};
export default CashinButtonContent;
